/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_ff421fae"]'><div :class='["radio-modal-default-demo"]'><cube-checkbox-group-modal ref="__mpx_ref_checkboxModal__" title="我是标题" subtitle="这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述" :show-close-icon="(true)" :options="(options)" :values="(value)" @close='(e)=>__invoke(e, [["onClose"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])'/><cube-button @_click="onTap">checkbox-modal-option-conf</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_ff421fae"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_ff421fae"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_ff421fae"}
  /** script content **/
  require("./checkbox-modal-option-conf.mpx.js?isComponent&outputPath=components%2Fcheckbox-modal-option-confff421fae%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./checkbox-modal-option-conf.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcheckbox-modal-option-confff421fae%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_ff421fae"],
    ctorType: "component",
    outputPath: "components/checkbox-modal-option-confff421fae/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-modal/index.mpx?isComponent&outputPath=components%2Findex37cd7d2c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>